// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject, ElementRef, Renderer2 } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwOrmDataServiceToken, DwOrmDataService, DwQueryHelper, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwComponentSectionConfigPreference, DwMdFormContextInfo, DwFormContextMode } from '@devwareapps/devware-cap';
import { DwFormControlLookupComponent } from '@devwareapps/devware-cap';
import { AppMetaDataService, LicensesEntity } from 'src/app/meta-data/app-meta-data.service';
import { flatMap, combineLatest, map, last } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { validateClaimsRequest } from 'msal/lib-commonjs/AuthenticationParameters';
import { AbstractControl, FormControl } from '@angular/forms';
import { ConfigService } from 'src/environments/environment';
import * as FilePond from 'filepond';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { FileControlConfigComponent } from './file-control-config/file-control-config.component';
import { FileControlConfig } from '../models/file-control-config.model';
import FilePondPluginImageOverlay from 'filepond-plugin-image-overlay';
import * as base64 from 'base64-arraybuffer';
import { any } from 'underscore';


@DwComponent({
  name: 'FileControl',
  isGlobal: true,
  componentType: DwComponentType.formSection,
  configComponent : FileControlConfigComponent
})

@Component({
  selector: 'app-file-control',
  templateUrl: './file-control.component.html',
  styleUrls: ['./file-control.component.scss']
})
export class FileControlComponent extends DwSectionBaseComponent<DwComponentSectionConfigPreference<FileControlConfig>>

  implements OnInit {
    BatchNumber: number = null;
    count: number = 0;
    trustUserId: number = this.getTrustUserid();
    filePondObject = null;
    //formContext: DwMdFormContextInfo = this.context[DwMdFormContextInfo.FORM_CONTEXT_NAME].value;

    pondOptions = {
      allowDownloadByUrl: true,
      multiple: true,
      labelIdle: 'Click to add files or Drop files here',
      allowRevert: false,
      allowRemove: false,

      server: {

          process: ConfigService.config.wAppsApi + 'api/v2/file?TrustId=' + this.trustUserId + '&BatchNumber=' + this.BatchNumber,
          fetch: null,
          revert: ConfigService.config.wAppsApi + 'api/v2/file?TrustId=' +  + this.trustUserId,

          load: ConfigService.config.wAppsApi + 'api/v2/file?json=',
           /* load: (source, load, error, progress, abort, headers) => {
            // Should request a file object from the server here
            // ...
            let urlstring = environment.wAppsApi +'api/v2/file?json=' + source;
            // Can call the error method if something is wrong, should exit after
            //this.http.get(url + )
            error('oh my goodness');

            // Can call the header method to supply FilePond with early response header string
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders
            //headers(headersString);

            // Should call the progress method to update the progress to 100% before calling load
            // (endlessMode, loadedSize, totalSize)
            progress(true, 0, 1024);

            // Should call the load method with a file object or blob when done
            //load(file);

            // Should expose an abort method so the request can be cancelled
            return {
                abort: () => {
                    // User tapped cancel, abort our ongoing actions here

                    // Let FilePond know the request has been cancelled
                    abort();
                }
            };
          }, */
         // onload: (response) => console.log(response.key)
      },
    //   fileRenameFunction: (file) => {
    //     return `my_new_name${file.extension}`;
    // }
    }
    pondFiles : any = [];
  wAppsApiUrl: string;
  FileControlConfig: FileControlConfig;
  @ViewChild('myPond') myPond: FilePond.FilePond;
  @ViewChild('fileDiv') myPondElement: ElementRef;
  bearerToken: string;

  // fileId: number;
  constructor(private renderer:Renderer2,
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private securityService: DwSecurityUserService,
    @Inject(DwSecurityRepositoryServiceToken) private securityRepository: DwSecurityRepositoryService,
    private messageService: DwMessagingService,
    private http: HttpClient) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  async ngOnInit() {

    super.ngOnInit();

    this.wAppsApiUrl = ConfigService.config.wAppsApi;
    this.FileControlConfig = this.sectionConfig.config;

    await this.delay(1000);
    this.BatchNumber = 0;
    this.setPondOptions();
    const ob3 : Observable<any> = this.getFiles()
    ob3.subscribe(x => {
      x.forEach(
        z => {
          z.forEach(y => {
        console.log(this.wAppsApiUrl + "api/v2/file?FileGUID=" + y.FileKey);
      //this.myPond.addFile(this.wAppsApiUrl + "api/v2/file?FileGUID=" + y[0].FileKey);
      const responseDetails : Observable<any> = this.http.get(this.wAppsApiUrl + "api/v2/file?FileGUID=" + y.FileKey + "&Details=true")
      this.count++;
      responseDetails.subscribe(xx => {
        var blob: BlobPart[] = [];
        blob.push(this.base64toBlob(xx.Base64, xx.FileType));
        var f = new File(blob,xx.FileName)
        //this.renderer.crea

        this.pondFiles.push({
          // the server file reference
          source: xx.Guid,

          // set type to local to indicate an already uploaded file
          options: {
              type: 'local',

              // mock file information
              file: f
          }
      });
      this.count--;

      this.myPondElement.nativeElement.children[0].remove();
      this.renderer.appendChild(this.myPondElement.nativeElement, this.renderer.createElement('input'));
      const inputTag = this.myPondElement.nativeElement.children[0];
      newFilePond = FilePond.create(inputTag , this.pondOptions);
      newFilePond.setOptions(this.pondOptions);
      newFilePond.allowMultiple = true;
      newFilePond.files = this.pondFiles;
      newFilePond.onremovefile = (x,y)=> {this.removeFile(x,y)};
      const formContext: DwMdFormContextInfo = this.context[DwMdFormContextInfo.FORM_CONTEXT_NAME].value;
      const canRevert = formContext.contextMode != DwFormContextMode.view;
      newFilePond.allowRevert = canRevert;
      const x : any = newFilePond
      x.allowRemove = canRevert;
      x.allowDrop = canRevert;
      newFilePond = x;
      newFilePond.labelIdle = canRevert ? 'Click to add files or Drop files here' : '';
      newFilePond.allowProcess = canRevert;
      newFilePond.allowBrowse = canRevert;
      this.myPond = newFilePond;
      const pond = document.querySelector('.filepond--root');
      pond.addEventListener('FilePond:processfile', e => {
        this.pondHandleUploadFile(e);
      });

      },
      (error) => {
        console.log(error);
      })
      });




    })

    }
    )
    this.myPondElement.nativeElement.children[0].remove();
      this.renderer.appendChild(this.myPondElement.nativeElement, this.renderer.createElement('input'));
      const inputTag = this.myPondElement.nativeElement.children[0];
      var newFilePond = FilePond.create(inputTag , this.pondOptions);
      newFilePond.setOptions(this.pondOptions);
      newFilePond.allowMultiple = true;
      newFilePond.files = this.pondFiles;
      newFilePond.onremovefile = (x,y)=> {this.removeFile(x,y)};
      const formContext: DwMdFormContextInfo = this.context[DwMdFormContextInfo.FORM_CONTEXT_NAME].value;
      const canRevert = formContext.contextMode != DwFormContextMode.view;
      newFilePond.allowRevert = canRevert;
      const x : any = newFilePond
      x.allowRemove = canRevert;
      x.allowDrop = canRevert;
      newFilePond = x;
      newFilePond.labelIdle = canRevert ? 'Click to add files or Drop files here' : '';
      newFilePond.allowProcess = canRevert;
      newFilePond.allowBrowse = canRevert;
      this.myPond = newFilePond;
      const pond = document.querySelector('.filepond--root');
      pond.addEventListener('FilePond:processfile', e => {
        this.pondHandleUploadFile(e);
      });

    // )
    // ob3.pipe(flatMap(x => x.forEach(y => {
    //   this.myPond.addFile(this.wAppsApiUrl + "api/v2/file?FileGUID=" + y.FileKey)
    // })
    // ))


  }

  pondHandleInit() {
  }

  pondHandleAddFile(event: any) {
  }

  pondHandleUploadFile(event: any){

    this.myPond.getFiles().forEach(x => {
     const y = JSON.parse(x.serverId);
      console.log(y.Guid);
      console.log(y.FileId);
      this.BatchNumber = y.BatchNumber;
      this.setPondOptions();
      this.writeFileId(this.BatchNumber);
    })

  }

setPondOptions(){
  const formContext: DwMdFormContextInfo = this.context[DwMdFormContextInfo.FORM_CONTEXT_NAME].value;
  const canRevert = formContext.contextMode != DwFormContextMode.view;
  this.pondOptions = {
    allowDownloadByUrl: true,
    multiple: true,
    labelIdle: 'Click to add files or Drop files here',
    allowRemove: canRevert,
    allowRevert: canRevert,
    server: {

        process: !canRevert ? null : ConfigService.config.wAppsApi + 'api/v2/file?TrustId=' + this.trustUserId + '&BatchNumber=' + this.BatchNumber,
        fetch: null,
        revert: ConfigService.config.wAppsApi + 'api/v2/file?TrustId=' +  + this.trustUserId,
        load: ConfigService.config.wAppsApi + 'api/v2/file?json=',
         /* load: (source, load, error, progress, abort, headers) => {
          // Should request a file object from the server here
          // ...
          let urlstring = environment.wAppsApi +'api/v2/file?json=' + source;
          // Can call the error method if something is wrong, should exit after
          // +  x.headers.get('content-disposition: ') + '\r\n'
          headers('content-disposition: inline; name=tmcLive.png; filename=tmcLive.png;\r\ncontent-type: image/png\r\ncontent-length: 83545');


          //error('oh my goodness');
          //source = 'test';
          // Can call the header method to supply FilePond with early response header string
          // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders
          headers('content-disposition: inline; name=tmcLive.png; filename=tmcLive.png;\r\ncontent-type: image/png\r\ncontent-length: 83545');

          // Should call the progress method to update the progress to 100% before calling load
          // (endlessMode, loadedSize, totalSize)
          //progress(true, 0, 1024);

          // Should call the load method with a file object or blob when done
          //this.filePondObject.getFiles().forEach(x => console.log(x.filename))

          // Should expose an abort method so the request can be cancelled
          return {
              abort: () => {
                  // User tapped cancel, abort our ongoing actions here

                  // Let FilePond know the request has been cancelled
                  abort();
              }
          };
        }, */
        //onload: (response) => console.log(response.key)
    },
  //   fileRenameFunction: (file) => {
  //     return `my_new_name${file.extension}`;
  // }
  }
    return;

}
  private getFiles() {
    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();
    const query = md.Attachment.CreateQuery();
    const query2 = md.AttachmentFile.CreateQuery();
    
    const attachmentFileId = this.getAttributeValue(this.FileControlConfig.attachmentId);
    this.BatchNumber = attachmentFileId;
    this.setPondOptions();
    if (!attachmentFileId) {
      return of([]);
    }

    query.AddFilterAnd(qh.filters.Equal(md.Attachment.AttachmentId, attachmentFileId));

    const data : Observable<any> = this.dataService.executeQuery(query);

    // data.toPromise().then(val => {
    //   val.forEach(y => {

    //     query2.AddFilterOr(qh.filters.Equal(md.AttachmentFile.AttachmentFileId, y.AttachmentFileId));

    //   })
    // })

    /* await data.toPromise().then(val => val.forEach(y => {
      query2.AddFilterOr(qh.filters.Equal(md.AttachmentFile.AttachmentFileId, y.AttachmentFileId));
        console.log(y.AttachmentFileId);

    })); */
    var group = qh.filters.Group();
    const ob4 = data.pipe(map(function(val){
      console.log(val);
      val.forEach(y => {
        group.AddFilterOr(qh.filters.Equal(md.AttachmentFile.AttachmentFileId, y.AttachmentFileId));

        console.log(y.attachmentFileId);

    })
    query2.AddFilterAnd(group);
    query2.AddFilterAnd(qh.filters.Equal(md.AttachmentFile.IsDeleted, false));
    return query2;
  }))

  return ob4.pipe(map(x => this.dataService.executeQuery(x)));

  }


  getTrustUserid() {
    const wachterUser = new WachterUserExt(this.securityService.securityContext.AuthenticatedUser);

    return wachterUser.trustUserId;
  }

  writeFileId(fileId: number) {
    const control = this.getOrCreateFormControl(this.FileControlConfig.attachmentId);
     control.setValue(fileId);
  }

  /**
   * Returns the attachmentFile Form Control to get or set it's value
   */
 // get attachmentFileControl(x: FileControlConfigComponent): number {
 //   this.
 // }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }
  getAttributeValue(attrName: string) {
    const control = this.getOrCreateFormControl(attrName);


    if (!control) {
      console.warn(`Attribute ${attrName} as not found in the form group!`);
      return `${attrName} not found`;
    }

    return control.value;
  }
  getFileNameFromHttpResponse(contentDispositionHeader: string) {
    var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
    return result.replace(/"/g, '');
}
base64toBlob(base64Data, contentType) {
  contentType = contentType || '';
  var sliceSize = 1024;
  var byteCharacters = atob(base64Data);
  var bytesLength = byteCharacters.length;
  var slicesCount = Math.ceil(bytesLength / sliceSize);
  var byteArrays = new Array(slicesCount);

  for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
}
removeFile(error, file){
  const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    body: {
      Guid: file.source,

    },
  };

  this.http
    .delete(ConfigService.config.wAppsApi + 'api/v2/file?TrustId=' + this.trustUserId, options)
    .subscribe((s) => {
      console.log(s);
    });
}

}

